export default __webpack_public_path__ + "static/media/wine_dark.febc4fb3.png";